import { ModBox, Text } from '@jfs/ui-new'
import React from 'react'

const Retry = React.memo(({ onPress, item }: any) => {
  const handlePress = () => {
    onPress && onPress(item)
  }
  return (
    <ModBox width={55} h={24}>
      <ModBox
        borderWidth={1}
        borderColor={'GRAY_BORDER'}
        borderRadius={4}
        alignItems={'center'}
        justifyContent={'center'}
        onPress={handlePress}
        padding={4}
        underlayColor={'DISABLED_GREY'}>
        <Text title={'Retry'} color={'BLACK_21'} fontSize={12} fontFamily={'jiotype-medium'} />
      </ModBox>
    </ModBox>
  )
})

export { Retry }
